import $ from 'jquery';
window.$ = window.jQuery = $;

export function acfInit(){
    jQuery(document).ready(function ( $ ){
        $('.collapse__block--content').hide();
        $('.collapse__block--title').on('click', () => {
            var id = '#'+$('.collapse__block--title button').attr('data-collapse');
            $(`${id} .collapse__block--content`).slideToggle();
            $('.collapse__block--title button').toggleClass('active')
        });
    });
}